import { render } from "./BackupComplete.vue?vue&type=template&id=1cebd97a&scoped=true"
import script from "./BackupComplete.vue?vue&type=script&lang=js"
export * from "./BackupComplete.vue?vue&type=script&lang=js"

import "./BackupComplete.vue?vue&type=style&index=0&id=1cebd97a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cebd97a"]])

export default __exports__